import { ensureRouteData } from '@/app/query-client'
import { learningPathQueryOptions } from '@/features/courses/api/queries'
import type { RouterContext } from '@/routes/layouts/root'

/**
 * The `/courses/path` loader.
 *
 * MAIN: the active path. `null` (`LEARNING_PATH_NOT_FOUND` — what dev
 * answers today) is the screen's "on its way" state, never the error page.
 */
export async function loadLearningPath({
  context: { queryClient },
}: {
  context: RouterContext
}): Promise<void> {
  await ensureRouteData(queryClient, learningPathQueryOptions())
}
